/*
 * mobile navigation
*/

var functions = window.nffleet_functions;
var variables = window.nffleet_variables;

var mobileNavButton = document.getElementById("mobile-nav-button");
var mobileMenu = document.getElementById("mobile-nav");

mobileNavButton.addEventListener(variables.clickListener,
    function clickFunction() {
        var addOpenedClass = !this.classList.contains(variables.openedClass) && !mobileMenu.classList.contains(variables.openedClass);
        functions.handleClass(this, variables.openedClass, addOpenedClass);
        functions.handleClass(mobileMenu, variables.openedClass, addOpenedClass);
    });

var mobileMenuLinks = mobileMenu.getElementsByClassName("mobile-nav__menu-link");

var currentOpenedElement;
var currentOpenedArrow;

var mobileMenuLinkAction = function (e) {
    var menuLink = this;
    var menuItem = menuLink.parentElement;

    var arrow = menuLink.getElementsByClassName("mobile-nav__toggle-symbol");
    currentOpenedArrow = addOrRemoveOpenedClass(arrow, currentOpenedArrow);

    var subMenus = menuItem.getElementsByClassName("mobile-nav__sub-menu");
    currentOpenedElement = addOrRemoveOpenedClass(subMenus, currentOpenedElement);

    function addOrRemoveOpenedClass(array, currentElement) {

        if (array.length > 0) {
            var element = array[0];
            var addOpenedClass = !element.classList.contains(variables.openedClass);

            if (currentElement !== element) {
                functions.handleClass(currentElement, variables.openedClass, false);
                currentElement = element;
            }

            functions.handleClass(element, variables.openedClass, addOpenedClass);
        }

        return currentElement;
    }
};

for (var mobileMenuLinkIndex = 0; mobileMenuLinkIndex < mobileMenuLinks.length; mobileMenuLinkIndex++) {
    mobileMenuLinks[mobileMenuLinkIndex].addEventListener(variables.clickListener, mobileMenuLinkAction, false);
}

/*
 * mobile search
 */

var searchButtonMobile = document.getElementById("search-btn-mobile");
var headerBottom = document.getElementsByClassName('header__bottom')[0];

var searchForm;

searchButtonMobile.addEventListener(variables.clickListener, function () {
    if (searchForm) {
        searchForm.remove();
        searchForm = undefined;
    } else {
        searchForm = window.nffleet_searchForm(this.getAttribute('data-input-placeholder'));
        headerBottom.append(searchForm);
    }
});